const { getChildren } = require('./getChildren');
const { hasChild } = require('./hasChild');

function calculateTaskProgress(task, gantt) {
  if (hasChild(task.id, gantt)) {
    const children = getChildren(task.id, gantt).filter((task) => task.type !== 'placeholder');
    const totalProgress = children.reduce(
      (sum, child) => sum + (parseFloat(child.progress) || 0),
      0
    );
    return parseFloat(parseFloat(totalProgress / children.length).toFixed(2));
  } else {
    return task.progress;
  }
}
module.exports = { calculateTaskProgress };
